var U = Object.defineProperty;
var N = (s, a, e) => a in s ? U(s, a, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[a] = e;
var g = (s, a, e) => N(s, typeof a != "symbol" ? a + "" : a, e);
import { DatasetController as P, Element as W, Chart as V } from "chart.js";
class A extends P {
  constructor(a, e) {
    super(a, e);
  }
}
g(A, "id", "map"), g(A, "defaults", {
  dataElementType: "polygon"
}), g(A, "overrides", {
  animations: !1,
  interaction: {
    mode: "nearest",
    intersect: !0
  },
  scales: {
    x: {
      display: !1
    },
    y: {
      display: !1
    }
  }
});
const b = [
  "rgb(54, 162, 235)",
  // blue
  "rgb(255, 99, 132)",
  // red
  "rgb(255, 159, 64)",
  // orange
  "rgb(255, 205, 86)",
  // yellow
  "rgb(75, 192, 192)",
  // green
  "rgb(153, 102, 255)",
  // purple
  "rgb(201, 203, 207)"
  // grey
], T = /* @__PURE__ */ b.map((s) => s.replace("rgb(", "rgba(").replace(")", ", 0.5)")), L = () => typeof window < "u" && !!window.google && !!window.google.maps;
class C extends P {
  constructor(e, l) {
    super(e, l);
    g(this, "polygons", []);
    g(this, "gmap", null);
    L() && (this.gmap = e.map || null, this.gmap || console.warn("PolygonController: Google Map instance not found on chart object. Polygons will not be drawn."));
  }
  _createGooglePolygon(e, l) {
    if (!L() || !this.gmap || !e || !e.data || e.data.length === 0)
      return null;
    const o = window.google.maps.LatLng, y = window.google.maps.Polygon, p = e.data.map((i) => new o(i[0], i[1])), t = new y({
      paths: p,
      strokeColor: e.borderColor || b[l % b.length],
      strokeOpacity: 0.8,
      strokeWeight: e.borderWidth || 2,
      fillColor: e.backgroundColor || T[l % T.length],
      fillOpacity: 0.35
    });
    return t.setMap(this.gmap), t;
  }
  update(e) {
    if (super.update(e), this.removePolygonsFromMap(), !L() || !this.gmap)
      return;
    const l = this.chart.data.datasets[this.index], o = [];
    if (l && Array.isArray(l.data)) {
      const y = this._createGooglePolygon(l, this.index);
      y && o.push(y);
    }
    this.polygons = o;
  }
  removePolygonsFromMap() {
    L() && this.gmap && this.polygons.forEach((e) => {
      e && e.setMap(null);
    }), this.polygons = [];
  }
  destroy() {
    this.removePolygonsFromMap();
  }
  draw() {
  }
}
g(C, "id", "polygon"), g(C, "defaults", {
  dataElementType: "polygon"
}), g(C, "overrides", {
  animations: !1,
  interaction: {
    mode: "nearest",
    intersect: !0
  },
  scales: {
    x: {
      display: !1
    },
    y: {
      display: !1
    }
  }
});
const $ = () => typeof window < "u" && !!window.google && !!window.google.maps;
class F extends P {
  constructor(e, l) {
    super(e, l);
    g(this, "points", []);
  }
  // Use conditional type for the instance property
  getDataset() {
    let e = this.chart.data.datasets[this.index];
    return {
      ...e,
      backgroundColor: e.backgroundColor || T[this.index % T.length],
      borderColor: e.borderColor || b[this.index % b.length]
    };
  }
  normalizeData(e) {
    return Array.isArray(e) && typeof e[0] == "number" && typeof e[1] == "number" ? [[e[0], e[1]]] : Array.isArray(e) && Array.isArray(e[0]) ? e : [];
  }
  drawPoints(e) {
    const l = this.chart.map;
    if (!$() || !l) return;
    this.normalizeData(e.data).forEach((y) => {
      const p = new window.google.maps.LatLng(
        parseFloat(y[0].toFixed(6)),
        parseFloat(y[1].toFixed(6))
      ), t = new window.google.maps.Marker({
        position: p,
        map: l,
        title: e.label,
        icon: {
          path: window.google.maps.SymbolPath.CIRCLE,
          // Direct usage, guarded by isGoogleMapsAvailable
          scale: 8,
          fillColor: e.backgroundColor,
          strokeColor: e.borderColor,
          fillOpacity: 1,
          strokeWeight: e.borderWidth || 1
        }
      });
      t.addListener("click", () => {
        if (!$() || !l) return;
        new window.google.maps.InfoWindow({
          content: `<h3 style="font-size: 16px; font-weight: bold; margin-top: 0px; margin-bottom: 0px">${e.label}</h3>`,
          ariaLabel: e.label
        }).open({
          anchor: t,
          map: l
        });
      }), this.points.push(t);
    });
  }
  clearPoints() {
    !$() || !this.chart.map || (this.points.forEach((e) => e.setMap(null)), this.points = []);
  }
  update(e) {
    const l = this._cachedMeta, o = this.getDataset(), y = this.chart.map;
    if (!$() || !y) {
      (e === "hide" || e === "reset" || l && l.hidden) && (this.points = []);
      return;
    }
    (e === "show" || e === "default") && this.points.length === 0 && l && !l.hidden ? this.drawPoints(o) : (e === "hide" || e === "reset" || l && l.hidden) && this.points.length > 0 && this.clearPoints();
  }
}
g(F, "id", "marker"), g(F, "defaults", {
  dataElementType: "marker"
}), g(F, "overrides", {
  interaction: {
    mode: "nearest",
    intersect: !0
  },
  scales: {
    x: {
      display: !1
    },
    y: {
      display: !1
    }
  }
});
function q(s) {
  return s && s.__esModule && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s;
}
var z = { exports: {} };
(function(s) {
  (function() {
    function a(t, i) {
      var n = t.x - i.x, d = t.y - i.y;
      return n * n + d * d;
    }
    function e(t, i, n) {
      var d = i.x, h = i.y, r = n.x - d, c = n.y - h;
      if (r !== 0 || c !== 0) {
        var f = ((t.x - d) * r + (t.y - h) * c) / (r * r + c * c);
        f > 1 ? (d = n.x, h = n.y) : f > 0 && (d += r * f, h += c * f);
      }
      return r = t.x - d, c = t.y - h, r * r + c * c;
    }
    function l(t, i) {
      for (var n = t[0], d = [n], h, r = 1, c = t.length; r < c; r++)
        h = t[r], a(h, n) > i && (d.push(h), n = h);
      return n !== h && d.push(h), d;
    }
    function o(t, i, n, d, h) {
      for (var r = d, c, f = i + 1; f < n; f++) {
        var m = e(t[f], t[i], t[n]);
        m > r && (c = f, r = m);
      }
      r > d && (c - i > 1 && o(t, i, c, d, h), h.push(t[c]), n - c > 1 && o(t, c, n, d, h));
    }
    function y(t, i) {
      var n = t.length - 1, d = [t[0]];
      return o(t, 0, n, i, d), d.push(t[n]), d;
    }
    function p(t, i, n) {
      if (t.length <= 2) return t;
      var d = i !== void 0 ? i * i : 1;
      return t = n ? t : l(t, d), t = y(t, d), t;
    }
    s.exports = p, s.exports.default = p;
  })();
})(z);
var H = z.exports;
const K = /* @__PURE__ */ q(H), S = () => typeof window < "u" && !!window.google && !!window.google.maps;
class k extends P {
  constructor(e, l) {
    super(e, l);
    g(this, "polyline", null);
  }
  drawLine(e) {
    const l = this.chart.map;
    if (!S() || !l) return;
    var o = new window.google.maps.LatLngBounds();
    let y = [];
    e.data.length > 100 ? y = K(e.data.map((t) => ({ x: t[0], y: t[1] })), 0.1).map((t) => [t.x, t.y]) : y = e.data, y = y.map((t) => [parseFloat(t[0].toFixed(6)), parseFloat(t[1].toFixed(6))]);
    const p = y.map(([t, i]) => {
      const n = new window.google.maps.LatLng(t, i);
      return o.extend(n), n;
    });
    this.polyline = new window.google.maps.Polyline({
      path: p,
      geodesic: !0,
      strokeColor: e.borderColor,
      strokeOpacity: 1,
      strokeWeight: e.borderWidth || 2
    }), this.polyline.addListener("click", () => {
      if (!S() || !l) return;
      const t = new window.google.maps.InfoWindow({
        content: `<h3 style="font-size: 16px; font-weight: bold; margin-top: 0px; margin-bottom: 0px">${e.label}</h3>`,
        ariaLabel: e.label
      });
      t.setPosition(o.getCenter()), t.open({
        map: l
      });
    }), this.polyline.setMap(l);
  }
  getDataset() {
    let e = this.chart.data.datasets[this.index];
    return {
      ...e,
      backgroundColor: e.backgroundColor || T[this.index % T.length],
      borderColor: e.borderColor || b[this.index % b.length]
    };
  }
  update(e) {
    const l = this._cachedMeta, o = this.getDataset(), y = this.chart.map;
    if (!S() || !y) {
      (e === "hide" || e === "reset" || l && l.hidden) && this.polyline && (this.polyline = null);
      return;
    }
    (e === "show" || e === "default") && !this.polyline && l && !l.hidden ? this.drawLine(o) : (e === "hide" || e === "reset" || l && l.hidden) && this.polyline && (this.polyline.setMap(null), this.polyline = null);
  }
}
g(k, "id", "polyline"), g(k, "defaults", {
  dataElementType: "polyline"
}), g(k, "overrides", {
  interaction: {
    mode: "nearest",
    intersect: !0
  },
  scales: {
    x: {
      display: !1
    },
    y: {
      display: !1
    }
  }
});
const B = [
  {
    elementType: "geometry",
    stylers: [
      {
        color: "#f5f5f5"
      }
    ]
  },
  {
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#616161"
      }
    ]
  },
  {
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#f5f5f5"
      }
    ]
  },
  {
    featureType: "administrative.land_parcel",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "administrative.land_parcel",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#bdbdbd"
      }
    ]
  },
  {
    featureType: "administrative.neighborhood",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [
      {
        color: "#eeeeee"
      }
    ]
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#757575"
      }
    ]
  },
  {
    featureType: "poi.business",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [
      {
        color: "#e5e5e5"
      }
    ]
  },
  {
    featureType: "poi.park",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#9e9e9e"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [
      {
        color: "#ffffff"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "labels",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "road.arterial",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#757575"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [
      {
        color: "#dadada"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#616161"
      }
    ]
  },
  {
    featureType: "road.local",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#9e9e9e"
      }
    ]
  },
  {
    featureType: "transit.line",
    elementType: "geometry",
    stylers: [
      {
        color: "#e5e5e5"
      }
    ]
  },
  {
    featureType: "transit.station",
    elementType: "geometry",
    stylers: [
      {
        color: "#eeeeee"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      {
        color: "#c9c9c9"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#9e9e9e"
      }
    ]
  }
], j = [
  {
    elementType: "geometry",
    stylers: [
      {
        color: "#242f3e"
      }
    ]
  },
  {
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#746855"
      }
    ]
  },
  {
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#242f3e"
      }
    ]
  },
  {
    featureType: "administrative.land_parcel",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "administrative.locality",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#d59563"
      }
    ]
  },
  {
    featureType: "administrative.neighborhood",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#d59563"
      }
    ]
  },
  {
    featureType: "poi.business",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [
      {
        color: "#263c3f"
      }
    ]
  },
  {
    featureType: "poi.park",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#6b9a76"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [
      {
        color: "#38414e"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#212a37"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "labels",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#9ca5b3"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [
      {
        color: "#746855"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#1f2835"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#f3d19c"
      }
    ]
  },
  {
    featureType: "transit",
    elementType: "geometry",
    stylers: [
      {
        color: "#2f3948"
      }
    ]
  },
  {
    featureType: "transit.station",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#d59563"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      {
        color: "#17263c"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#515c6d"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#17263c"
      }
    ]
  }
];
function R(s) {
  if (!s || s.startsWith("#") || /^[0-9A-Fa-f]{6}$/.test(s))
    return s;
  const a = s.match(/^rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/);
  if (a) {
    const l = parseInt(a[1], 10), o = parseInt(a[2], 10), y = parseInt(a[3], 10);
    return `#${((1 << 24) + (l << 16) + (o << 8) + y).toString(16).slice(1)}`;
  }
  const e = s.match(/^rgba\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)$/);
  if (e) {
    const l = parseInt(e[1], 10), o = parseInt(e[2], 10), y = parseInt(e[3], 10);
    return `#${((1 << 24) + (l << 16) + (o << 8) + y).toString(16).slice(1)}`;
  }
  return s;
}
const x = () => typeof window < "u" && !!window.google && !!window.google.maps, Q = (s) => s.map((a) => {
  let e = a.featureType || "all", l = a.elementType || "all", o = a.stylers.map((y) => {
    const p = Object.keys(y)[0], t = y[p];
    return p === "visibility" ? `visibility:${t}` : p === "color" ? `color:0x${t.startsWith("#") ? t.substring(1) : t}` : `${p}:${t}`;
  }).join("|");
  return `style=feature:${e}|element:${l}|${o}`;
}).join("&"), Y = {
  id: "map",
  beforeInit: (s) => {
    const e = typeof window < "u" ? s.canvas.parentElement : null, l = s.options;
    if (x() && e) {
      const o = document.createElement("div");
      o.style.position = "absolute", o.style.left = "0px", o.style.top = "0px", o.style.width = "100%", o.style.height = "100%", o.style.borderRadius = "8px", e.appendChild(o);
      const y = new window.google.maps.Map(o, {
        zoom: 2,
        center: { lat: 0, lng: 0 },
        mapTypeId: window.google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: !0,
        styles: l.theme === "light" ? B : j
      });
      s.map = y;
    } else
      s.useStaticMap = !0;
  },
  // Create a function to render static map image
  renderStaticMap: (s, a, e, l, o) => {
    if (!s.useStaticMap) return;
    const y = s.options, p = "AIzaSyDqUZ6lVdQA-9iBpfI1q4mSCH9seg2E-7M";
    let t = Math.round(s.chartArea.width) || 640, i = Math.round(s.chartArea.height) || 480;
    if (t > 640 || i > 640) {
      const r = t / i;
      t >= i ? (t = 640, i = Math.round(t / r)) : (i = 640, t = Math.round(i * r));
    }
    let n = `https://maps.googleapis.com/maps/api/staticmap?size=${t}x${i}`;
    const d = y.theme === "light" ? B : j, h = Q(d);
    if (n += `&${h}`, e.forEach((r) => {
      if (isNaN(r.lat) || isNaN(r.lng) || r.lat < -90 || r.lat > 90 || r.lng < -180 || r.lng > 180) {
        console.warn("Invalid marker coordinates:", r);
        return;
      }
      const c = r.color || "red", f = c.startsWith("#") ? c.substring(1) : c, m = parseFloat(r.lat.toFixed(6)), w = parseFloat(r.lng.toFixed(6));
      n += `&markers=color:0x${f}|${m},${w}`;
    }), l.forEach((r) => {
      let c = r.color || "blue";
      c = c.startsWith("#") ? c.substring(1) : c;
      const f = r.weight || 5, m = r.points.map((w) => {
        const v = parseFloat(w[0].toFixed(6)), u = parseFloat(w[1].toFixed(6));
        return `${v},${u}`;
      }).join("|");
      m && (n += `&path=color:0x${c}|weight:${f}|${m}`);
    }), o.forEach((r) => {
      let c = r.fillColor || "00FF00", f = r.strokeColor || "005500";
      c = R(c), f = R(f), c = c.startsWith("#") ? c.substring(1) : c, f = f.startsWith("#") ? f.substring(1) : f;
      const m = r.weight || 2, w = r.points.map((u) => {
        if (!Array.isArray(u) || u.length < 2)
          return console.warn("Invalid polygon point:", u), null;
        const M = parseFloat(u[0].toFixed(6)), I = parseFloat(u[1].toFixed(6));
        return `${M},${I}`;
      }).filter((u) => u !== null).join("|");
      let v = w;
      if (r.points.length > 0 && w) {
        const u = r.points[0], M = r.points[r.points.length - 1];
        if (u[0] !== M[0] || u[1] !== M[1]) {
          const I = parseFloat(u[0].toFixed(6)), G = parseFloat(u[1].toFixed(6));
          v += `|${I},${G}`;
        }
      }
      v && (n += `&path=fillcolor:0x${c}80|color:0x${f}|weight:${m}|${v}`);
    }), a && a.southwest && a.northeast) {
      const r = (a.northeast.lat + a.southwest.lat) / 2, c = (a.northeast.lng + a.southwest.lng) / 2, f = parseFloat(r.toFixed(6)), m = parseFloat(c.toFixed(6));
      n += `&center=${f},${m}`;
    }
    n += `&key=${p}&scale=2`, s.staticMapUrl = n;
  },
  beforeDraw: (s) => {
    x() && s.map ? (s.map.getDiv().style.top = s.chartArea.top + "px", s.map.getDiv().style.left = s.chartArea.left + "px", s.map.getDiv().style.width = s.chartArea.width + "px", s.map.getDiv().style.height = s.chartArea.height + "px") : s.useStaticMap && s.staticMapImage && s.staticMapImage.complete && s.ctx.drawImage(s.staticMapImage, s.chartArea.left, s.chartArea.top, s.chartArea.width, s.chartArea.height);
  },
  afterUpdate: (s) => {
    const a = [], e = [], l = [];
    let o = {
      northeast: { lat: -90, lng: -180 },
      southwest: { lat: 90, lng: 180 }
    };
    const y = s._metasets.map((p) => p.hidden);
    if (s.data.datasets.filter((p, t) => !y[t]).forEach((p) => {
      p.type === "marker" ? (Array.isArray(p.data[0]) ? p.data : [p.data]).forEach((i) => {
        const n = i[0], d = i[1];
        if (o.northeast.lat = Math.max(o.northeast.lat, n), o.northeast.lng = Math.max(o.northeast.lng, d), o.southwest.lat = Math.min(o.southwest.lat, n), o.southwest.lng = Math.min(o.southwest.lng, d), a.push({
          lat: n,
          lng: d,
          color: p.borderColor || p.backgroundColor
        }), x() && s.map) {
          const h = new window.google.maps.LatLng(n, d);
          new window.google.maps.LatLngBounds().extend(h);
        }
      }) : p.type === "polyline" ? (e.push({
        points: p.data,
        color: p.borderColor,
        weight: p.borderWidth || 2
      }), p.data.forEach(([t, i]) => {
        if (o.northeast.lat = Math.max(o.northeast.lat, t), o.northeast.lng = Math.max(o.northeast.lng, i), o.southwest.lat = Math.min(o.southwest.lat, t), o.southwest.lng = Math.min(o.southwest.lng, i), x() && s.map) {
          const n = new window.google.maps.LatLng(t, i);
          new window.google.maps.LatLngBounds().extend(n);
        }
      })) : p.type === "polygon" && (l.push({
        points: p.data,
        fillColor: p.backgroundColor,
        strokeColor: p.borderColor,
        weight: p.borderWidth || 2
      }), p.data.forEach((t) => {
        if (Array.isArray(t)) {
          const i = t[0], n = t[1];
          if (o.northeast.lat = Math.max(o.northeast.lat, i), o.northeast.lng = Math.max(o.northeast.lng, n), o.southwest.lat = Math.min(o.southwest.lat, i), o.southwest.lng = Math.min(o.southwest.lng, n), x() && s.map) {
            const d = new window.google.maps.LatLng(i, n);
            new window.google.maps.LatLngBounds().extend(d);
          }
        }
      }));
    }), x() && s.map) {
      const p = new window.google.maps.LatLngBounds(
        new window.google.maps.LatLng(o.southwest.lat, o.southwest.lng),
        new window.google.maps.LatLng(o.northeast.lat, o.northeast.lng)
      );
      (a.length > 0 || e.length > 0 || l.length > 0) && s.map.fitBounds(p);
    } else if (s.useStaticMap) {
      const p = (o.northeast.lat - o.southwest.lat) * 0.1, t = (o.northeast.lng - o.southwest.lng) * 0.1;
      o.northeast.lat += p, o.northeast.lng += t, o.southwest.lat -= p, o.southwest.lng -= t, Y.renderStaticMap(s, o, a, e, l);
    }
  },
  defaults: {
    provider: "google",
    apiKey: "AIzaSyDqUZ6lVdQA-9iBpfI1q4mSCH9seg2E-7M"
    // Default API key
  }
}, _ = {
  backgroundColor: void 0,
  borderColor: void 0,
  borderWidth: void 0,
  borderRadius: 0,
  anchorX: "center",
  anchorY: "center",
  width: 20,
  height: 20
};
class E extends W {
  constructor(a) {
    super(), a && Object.assign(this, a);
  }
  draw(a) {
  }
}
g(E, "id", "marker"), g(E, "defaults", _);
class D extends W {
  constructor(a) {
    super(), a && Object.assign(this, a);
  }
  draw(a) {
  }
}
g(D, "id", "polyline"), g(D, "defaults", _);
class O extends W {
  constructor(a) {
    super(), a && Object.assign(this, a);
  }
  draw(a) {
  }
}
g(O, "id", "polygon"), g(O, "defaults", _);
V.register(A, C, F, k, D, E, O);
export {
  A as MapController,
  Y as MapPlugin,
  F as MarkerController,
  E as MarkerElement,
  C as PolygonController,
  O as PolygonElement,
  k as PolylineController,
  D as PolylineElement
};
//# sourceMappingURL=index.js.map
